<template>
  <div>
    <div class="flex items-start mt-2" v-bind="$attrs">
      <input
        :id="id"
        :value="modelValue"
        type="checkbox"
        :name="name"
        class="checkbox min-h-full"
        :class="{ 'has-error': error }"
        @change="$emit('update:modelValue', $event.target.checked)"
      />
      <label :for="id" class="font-medium text-sm pl-3 cursor-pointer">
        <slot />
      </label>
    </div>

    <ErrorMessage :error="error" />
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, watch } from 'vue'

import ErrorMessage from './ErrorMessage'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: undefined,
  },
  error: {
    type: String,
    default: undefined,
  },
})

const emit = defineEmits(['update:modelValue', 'update:error'])

const { uid } = getCurrentInstance()
const id = computed(() => `checkbox-${uid}`)

watch(
  () => props.modelValue,
  () => {
    emit('update:error', undefined)
  },
)
</script>

<style lang="postcss" scoped>
.checkbox {
  @apply flex items-center w-5 h-5;
  @apply outline-none rounded-sm cursor-pointer m-0;
  @apply border-0 text-blue-600;
  @apply transition-all duration-300;
}
.checkbox:focus {
  @apply ring-blue-500 ring-offset-gray-900;
}
.checkbox.has-error {
  @apply border-2 border-red-600;
}
</style>
